module.exports = __webpack_public_path__ + "img/Rupee.641c210b.png";